export default __webpack_public_path__ + "static/media/no_image_found.5882c20d.jpg";